const messages = {
    phone2FA: '2FA Phone',
    phoneNotification: 'Notification Phone',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    submit: 'Submit',
    myProfile: 'My Profile',
    passwordChangeSuccessfully: 'The password was change successfully',
    Password: 'Password',
    forgotPassword: 'Forgot Password',
    checkYourEmail: 'Please check your email.',
    enterEmailAssociatedYourAccount: 'Please enter the email associated with your account.',
    send: 'Send',
    enterYourNewPassword: 'Please enter your new password.',
    resetPassword: 'Reset Password',
    verifyYourIdentity: 'Verify Your Identity',
    receiveVerificationCode: 'Receive Verification Code by',
    enterCodeSentToYour: 'Please enter the code sent to your',
    rememberDevice30Days: 'Remember this device for 30 days',
    verify: 'Verify',
    resend: 'Resend',
    editPermissions: 'Permissions edited successfully',
    workingSince: 'Company Employee Since',
    confirmUnlockAccount: 'Confirm User Account Unblock',
    confirmLoginAccount: 'Confirm Login as user {field} account',
    noticeUnlock: 'This action allows the user to access the system, some data could be lost',
    noticeImpersonateLogin:
        'This action allows the user to access the system, some data could be lost',
    userAccountUnlokedSuccessfully: 'User account has been unloked successfully',
    login: 'Login',
    greeting: 'Hello',
    updatePasswordDescription:
        'We requires you to update your personal password, please, update it now',
    resetPasswordRequest: 'Reset Password',
    confirmRequestUpdatePassword: 'Confirm Update Password Request',
    requestUpdatePasswordSuccessfully: 'The password update request was created successfully.',
    noticeRequestUpdatePassword:
        'This action will prompt the user upon login to change their password',
    requestPasswordUpdate: 'Password change required',
    requestPasswordUpdateDescription: 'User must change their password at the next login',
    requireMfaReregister: 'Require re-register multifactor authentication',
    sent: 'Sent',
    myNotifications: 'My notifications',
    // Report Access keys
    failedToLoadData: 'Failed to load data',
    complaintsReport: 'Complaints Report',
    completedMassageReport: 'Completed Massage Report',
    cosmetologyProcedureReport: 'Cosmetology Procedure Report',
    cosmetologySalesReport: 'Cosmetology Sales Report',
    expensesByExternalProviderReport: 'Expenses by External Provider Report',
    generalCosmetologyReport: 'General Cosmetology Report',
    generalSurgeryReport: 'General Surgery Report',
    newLeadsReport: 'New Leads Report',
    paidInPayrollsByEmployeesReport: 'Paid in Payrolls by Employees Report',
    paidInPayrollsByStructureReport: 'Paid in Payrolls by Structure Report',
    productsSalesReport: 'Products Sales Report',
    providerChecksReport: 'Provider Checks Report',
    publicityCustomerSourcesReport: 'Publicity Customer Sources Report',
    salesBySellersReport: 'Sales by Sellers Report',
    surgeriesAndProceduresReport: 'Surgeries and Procedures Report',
    surgerySalesReport: 'Surgery Sales Report',
    totalSalesReport: 'Total Sales Report',
    workedHoursInPayrollsReport: 'Worked Hours in Payrolls Report',
    reportAccessSavedSuccessfully: 'Report access saved successfully',
    failedToSaveReportAccess: 'Failed to save report access',
    backToUsers: 'Back to Users',
    reports: 'Reports',
    selectReport: 'Select Report',
    selectAReport: 'Select a Report',
    bulkActions: 'Bulk Actions',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    officeStructure: 'Office Structure',
    searchOffices: 'Search offices...',
    selectAReportToViewOffices: 'Select a report to view offices',
    saving: 'Saving...',
    manageReportAccessForUser: 'Manage Report Access for User: {userName}',
    offices: 'offices',
    reportAccess: 'Report Access',
    unsavedChanges: 'You have unsaved changes. Do you really want to leave?',
};

export default messages;
